export const ON_CHECKOUT = 'dt:custom_tab_type:on_checkout';
export const PROCEED_TO_PAY = 'dt:custom_tab_type:proceed_to_pay';
